// export const contentAPI = process.env.NODE_ENV === 'development' ? 'http://api.coalescecreate.test/' : 'https://api.coalescecreate.com/';
export const contentAPI = 'https://api.coalescecreate.com/';

export const origin = 'https://www.coalescecreate.com';

export const urlRoots = [
	'coalesce',
];
